module.exports = __webpack_public_path__ + "static/stewart_sutherland_-_stronger_than_ever_compressed-c9efa10f12eeb5be3e62eb74d993b19b.mp4";